/** @format */

import EdilentWorkerApi from '@model/api';
import Validator from '@croco/validator';
import di from "dependeny-injection";

/**
 *
 * @package     edilent-worker
 */
class BankAccountWithApi extends EdilentWorkerApi {
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        super('info');
        this._clear();
        this._registerEvent();
    }

    /**
     * バリデーションの取得
     *
     * @access public
     * @return void
     */
    getValidation(name) {
        let validation = new Map([
            ['bank_name', {required: true, validate: false}],
            ['branch_name', {required: true, validate: false}],
            ['bank_code', {required: true, validate: false}],
            ['branch_code', {required: true, validate: false}],
            ['account_type', {required: true, validate: false}],
            ['account_number', {required: true, validate: 'int'}],
            ['account_name', {required: true, validate: 'multibyte'}]
        ]);

        if (validation.has(name)) {
            return validation.get(name);
        }

        return {required: false, validate: false};
    }

    /**
     * 変数の初期化
     *
     * @access private
     * @return void
     */
    _clear() {
        this.item = new Validator({
            bank_name: '',
            branch_name: '',
            bank_code: '',
            branch_code: '',
            account_type: '',
            account_number: '',
            account_name: '',
        });
        this.fieldsAlert = true;
        this.bank_account_status = null
    }

    /**
     * イベントの登録
     *
     * @access private
     * @return void
     */
    _registerEvent() {
        this.on('fetch', () => {
            this._fetch();
        });
        this.on('save', () => {
            this._save();
        });
    }

    hasFields() {
        let keys = this.item._keys;
        let array = [];
        for (let idx in keys) {
            if (this.item[keys[idx]]) {
                array.push(this.item[keys[idx]]);
            }
        }
        this.fieldsAlert = (0 === array.length);
        return this.fieldsAlert;
    }

    /**
     * 指定した制作実績の取得
     *
     * @access private
     * @return void
     */
    async _fetch() {
        this._clear();

        let item = await this.request('bankAccount', 'fetch');
        for (const key in item) {
            if (item.hasOwnProperty(key) && item[key]) {
                this.item.set(key, item[key], {required: true, validate: false});
            }
        }
        if (item && item.hasOwnProperty("status")) {
            this.bank_account_status = item.status;
        }
        this.hasFields();
        this.trigger('update');
    }

    /**
     * 銀行口座情報の更新
     *
     * @access private
     * @return void
     */
    async _save() {
        this.enable = this.item.validate();
        if (!this.enable) {
            this.trigger('update');
            return;
        }
        if (this.hasFields()) {
            this.trigger('update');
            return;
        }
        let data = new FormData();
        data.set('bank_code', this.item.bank_code);
        data.set('branch_code', this.item.branch_code);
        data.set('account_type', this.item.account_type);
        data.set('account_number', this.item.account_number);
        data.set('account_name', this.item.account_name);

        try {
            await this.request('bankAccount', 'save', data);
            di.toast.push(`銀行口座情報を変更しました。`, "success");
            di.router.push("/info/bank-account-confirm");
        } catch (e) {
            di.toast.push(e, "negative");
        }
    }
}

const bankAccountApi = new BankAccountWithApi();

export default bankAccountApi;
